import { Pagination } from "@/features/pagination/layouts/pagination";
import { PrivateRoomContractsListTable } from "@/features/private-room/contracts/list/layouts/list-table/list-table";

import { Button } from "@/components/ui/button";
import { useList } from "@/features/private-room/contracts/list/context/use-list";
import { EmptyState } from "@/features/private-room/contracts/list/shared/empty-state";
import { PageBreadcrumb } from "@/layouts/page-container/shared/breadcrumb";
import { PlusIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { DEFAULT_ROUTES } from "@/constants/routes";
import { FiltersPrivateOfficeContracts } from "@/features/private-room/contracts/list/layouts/filters-private-office-contracts/filters-private-office-contracts";
import { PrivateOfficeContractsDetails } from "@/features/private-room/contracts/list/layouts/private-office-contracts-details";
import { ButtonExportPoContracts } from "@/features/private-room/contracts/list/layouts/filters-private-office-contracts/shared/button-export-po-contracts";

export const PrivateRoomContractsList = () => {
  const {
    activePage,
    handleChangePage,
    decreasePage,
    increasePage,
    totalPages,
    isLoading,
    data,
    pagination,
  } = useList();

  return (
    <>
      <PageBreadcrumb title="Contratos de venda de escritório">
        <div className="flex items-center ml-auto">
          <ButtonExportPoContracts />

          <Button className="ml-2" disabled={isLoading}>
            <Link
              to={DEFAULT_ROUTES.PRIVATE_OFFICE_CONTRACTS_CREATE}
              className="flex"
            >
              <PlusIcon className="w-5" />
              Criar Contrato
            </Link>
          </Button>
        </div>
      </PageBreadcrumb>

      <FiltersPrivateOfficeContracts />

      {!isLoading && data?.length === 0 ? (
        <EmptyState
          title="Nenhum contrato encontrado"
          description="Nenhum contrato encontrado com os filtros aplicados."
        />
      ) : (
        <div className="flex h-full">
          <div className="flex-1 overflow-hidden flex flex-col justify-between px-8">
            <PrivateRoomContractsListTable data={data} isLoading={isLoading} />
            <PrivateOfficeContractsDetails />
            {isLoading ? (
              <div className="flex w-full justify-end m-4">
                <Skeleton className="w-[371px] h-[36px] rounded-full" />
              </div>
            ) : (
              <Pagination
                count={1000}
                page={activePage}
                onPageClick={handleChangePage}
                onPrevPageClick={decreasePage}
                onNextPageClick={increasePage}
                pageName="Private Offices Contracts"
                totalLines={`${pagination.total}`}
                totalPages={totalPages || 1}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
